import ApiService from './api.service.js';

export default {
  fetchGroups(params) {
    return ApiService.get(`/core/groups`, { params });
  }
};
